export const
	BREAKPOINT_CHANGE = 'BREAKPOINT_CHANGE',
	// module dropdown
	DROPDOWN_CLICKED = 'DROPDOWN_CLICKED',
	// module hamburger
	HAMBURGER_CLICKED = 'HAMBURGER_CLICKED',

	// login widget module request
	LOGIN_WIDGET_RESPONSE_SUCCESS = "LW_RESPONSE_SUCCESS",
	LOGIN_WIDGET_RESPONSE_ERROR = "LW_RESPONSE_ERROR",

	// Teetime component
	TEETIMES_LOADED = 'TEETIMES_LOADED',
	TEETIMES_UNAVAILABLE = 'TEETIMES_UNAVAILABLE',
	TEETIMES_AVAILABLE = 'TEETIMES_AVAILABLE',

	TAB_ACTIVATED = 'TAB_ACTIVATED',
	TAB_SWITCHED = 'TAB_SWITCHED',
	TOGGLE_CLOSE = 'TOGGLE_CLOSE',

	// module search
	SEARCH_CLICKED = 'SEARCH_CLICKED',

	// filter component
	FILTER_CHANGED = 'FILTER_CHANGED',
	VALUE_SELECTED = 'VALUE_CHANGED',

	// Card component
	CARD_ADDED = 'CARD_ADDED',
	CARD_REMOVED = 'CARD_REMOVED',

	//Rule Exam component
	EXAM_LOADED = 'EXAM_LOADED',

	// Coveo initialized
	COVEO_INITIALIZED = "COVEO_INITIALIZED"
	;
